<div class="mat-typography carta-porte-view">
	<mat-label><span>CTG: </span>{{ data.numeroCTG }}</mat-label>
	<mat-label><span>Titular: </span>{{ data.titular.razonSocial }}</mat-label>
	<mat-label><span>Destino: </span>{{ data.destino.razonSocial }}</mat-label>
	<mat-label
		><span>Destinatario: </span>{{ data.destinatario.razonSocial }}</mat-label
	>
	<mat-label><span>RUCA Origen: </span>{{ data.rucaOrigen || '-' }}</mat-label>
	<mat-label
		><span>RUCA Destino: </span>{{ data.rucaDestino || '-' }}</mat-label
	>
	@if (data.pesoNetoCargaKg) {
		<mat-label><span>Neto Carga: </span>{{ data.pesoNetoCargaKg }}</mat-label>
	}
	@if (data.pesoNetoDescargaKg) {
		<mat-label
			><span>Neto Descarga: </span>{{ data.pesoNetoDescargaKg }}</mat-label
		>
	}
	@if (data.pesoNetoIngresoStockKg) {
		<mat-label
			><span>Neto Ingreso Stock: </span
			>{{ data.pesoNetoIngresoStockKg }}</mat-label
		>
	}
	<mat-label>
		<span>Fecha Movimiento: </span>{{ data.fechaMovimiento }}</mat-label
	>
</div>
@if (data.unidadProductiva) {
	<div class="mat-typography carta-porte-view">
		<mat-label
			><span>Codigo UP: </span>{{ data.unidadProductiva.id }}</mat-label
		>
		<mat-label
			><span>Descripcion UP: </span
			>{{ data.unidadProductiva.descripcion || '-' }}</mat-label
		>
		<mat-label
			><span>RENSPA: </span
			>{{ data.unidadProductiva.numeroRENSPA || '-' }}</mat-label
		>
		<mat-label
			><span>Localidad: </span>{{ data.unidadProductiva.localidad }}</mat-label
		>
		<mat-label
			><span>Provincia: </span>{{ data.unidadProductiva.provincia }}</mat-label
		>
	</div>
}
